import BaseAPI from "./BaseAPI";
import { sensorLogRoute } from "../routes";

export default class SensorLogAPI extends BaseAPI {
    constructor(emitterInstance) {
        super(emitterInstance, sensorLogRoute, "sensor-log");
    }

    async ListBySensorIDAfter(id, after) {
        return this._request("get", this._url(`?after=${after}&sensor_id=${id}`));
    }

    async ListToday(options = {}) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let todayMs = today.getTime();
        return this._request("get", this._url(`?after=${todayMs}`), null, options);
    }
}
